"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Card_1 = __importDefault(require("../Card"));
exports.RecoSliderWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /** For lazyLoading it must have a size */\n  min-height: 1px;\n  min-width: 1px;\n"], ["\n  /** For lazyLoading it must have a size */\n  min-height: 1px;\n  min-width: 1px;\n"])));
var ItemWrapperNoCard = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0 5px;\n"], ["\n  padding: 0 5px;\n"])));
exports.WrappedCard = function (_a) {
    var children = _a.children, cardLayout = _a.cardLayout;
    return cardLayout ? (react_1.default.createElement(Card_1.default, null, children)) : (react_1.default.createElement(ItemWrapperNoCard, { "data-testid": "noCard" }, children));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map